import { render, staticRenderFns } from "./resend-link.vue?vue&type=template&id=5446811c&scoped=true&"
import script from "./resend-link.vue?vue&type=script&lang=js&"
export * from "./resend-link.vue?vue&type=script&lang=js&"
import style0 from "./resend-link.vue?vue&type=style&index=0&id=5446811c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5446811c",
  null
  
)

export default component.exports